import React, { FC, useState, useEffect, useRef } from "react";
import "./tableHeader.scss";
import { useTranslation } from "react-i18next";
import TableHeaderCards from "./TableHeaderCards";
import { TableCard } from "../../../common/types/tableCardType";
import Notification from "../../../components/notification/Notification";
import NotificationPanel from "../../notification/NotificationPanel";

interface TableHeaderParams {
  headerHeadline: string;
  cards: TableCard[];
}

const TableHeader: FC<TableHeaderParams> = ({ headerHeadline, cards }) => {
  const { t } = useTranslation();
  const [isNotificationPanelOpen, setIsNotificationPanelOpen] = useState(false);
  const notificationRef = useRef<HTMLDivElement>(null); // Ref for the notification container

  const handleNotificationClick = () => {
    setIsNotificationPanelOpen((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target as Node)
    ) {
      setIsNotificationPanelOpen(false);
    }
  };

  useEffect(() => {
    if (isNotificationPanelOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside); 
    };
  }, [isNotificationPanelOpen]);

  return (
    <div className="table-header-main-container">
      <div className="main-headline-container">
        <h2 className="main-headline">{headerHeadline}</h2>
        <div
          className="table-header-notifications"
          style={{ position: "relative" }}
          ref={notificationRef} 
        >
          <Notification onClick={handleNotificationClick} />
          {isNotificationPanelOpen && (
            <NotificationPanel
              onClose={() => setIsNotificationPanelOpen(false)}
            />
          )}
        </div>
      </div>
      <div className="patients-cards">
        <TableHeaderCards cards={cards} />
      </div>
    </div>
  );
};

export default TableHeader;
